import { render, staticRenderFns } from "./addDropBrand.vue?vue&type=template&id=562810ca&scoped=true&"
import script from "./addDropBrand.vue?vue&type=script&lang=js&"
export * from "./addDropBrand.vue?vue&type=script&lang=js&"
import style0 from "./addDropBrand.vue?vue&type=style&index=0&id=562810ca&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562810ca",
  null
  
)

export default component.exports